import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiShield, FiMail, FiMapPin, FiLinkedin, FiTwitter, FiGlobe } = FiIcons;

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-emerald-950 text-white relative overflow-hidden">
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0zNiAxOGMzLjMxNCAwIDYgMi42ODYgNiA2cy0yLjY4NiA2LTYgNi02LTIuNjg2LTYtNiAyLjY4Ni02IDYtNiIgc3Ryb2tlPSIjMTBiOTgxIiBzdHJva2Utd2lkdGg9IjIiIG9wYWNpdHk9Ii4xIi8+PC9nPjwvc3ZnPg==')] opacity-20"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 relative">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div className="md:col-span-2">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="flex items-center space-x-4 mb-6"
            >
              <div className="w-12 h-12 bg-gradient-to-br from-emerald-500 to-green-700 rounded-xl flex items-center justify-center shadow-lg">
                <SafeIcon icon={FiShield} className="w-7 h-7 text-white" />
              </div>
              <div>
                <span className="text-2xl font-bold" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>vMLRO</span>
                <p className="text-sm text-emerald-300">TruSecure SRL</p>
              </div>
            </motion.div>
            
            <p className="text-gray-300 mb-6 leading-relaxed">
              Professional Virtual Money Laundering Reporting Officer services by TruSecure SRL, 
              an Oxford Holding company. Expert AML/CFT compliance solutions tailored to your business needs.
            </p>
            
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiGlobe} className="w-5 h-5 text-emerald-400" />
                <span className="text-gray-300">vmlro.com</span>
              </div>
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiMail} className="w-5 h-5 text-emerald-400" />
                <span className="text-gray-300">contact@vmlro.com</span>
              </div>
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiMapPin} className="w-5 h-5 text-emerald-400" />
                <span className="text-gray-300">Romania</span>
              </div>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>Services</h4>
            <ul className="space-y-3 text-gray-300">
              <li><a href="#solutions" className="hover:text-emerald-400 transition-colors">Risk Assessment</a></li>
              <li><a href="#solutions" className="hover:text-emerald-400 transition-colors">Policy Development</a></li>
              <li><a href="#solutions" className="hover:text-emerald-400 transition-colors">Regulatory Reporting</a></li>
              <li><a href="#solutions" className="hover:text-emerald-400 transition-colors">Ongoing Monitoring</a></li>
              <li><a href="#solutions" className="hover:text-emerald-400 transition-colors">Staff Training</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>Industries</h4>
            <ul className="space-y-3 text-gray-300">
              <li><a href="#use-cases" className="hover:text-emerald-400 transition-colors">FinTech & Payments</a></li>
              <li><a href="#use-cases" className="hover:text-emerald-400 transition-colors">Real Estate</a></li>
              <li><a href="#use-cases" className="hover:text-emerald-400 transition-colors">Professional Services</a></li>
              <li><a href="#use-cases" className="hover:text-emerald-400 transition-colors">Gaming & Entertainment</a></li>
              <li><a href="#use-cases" className="hover:text-emerald-400 transition-colors">Cryptocurrency</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-400 text-sm mb-4 md:mb-0">
              © {currentYear} vMLRO - TruSecure SRL. An Oxford Holding Company. All rights reserved.
            </div>
            
            <div className="flex items-center space-x-6">
              <a href="#" className="text-gray-400 hover:text-emerald-400 transition-colors text-sm">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-400 hover:text-emerald-400 transition-colors text-sm">
                Terms of Service
              </a>
              <div className="flex items-center space-x-4">
                <a href="#" className="text-gray-400 hover:text-emerald-400 transition-colors">
                  <SafeIcon icon={FiLinkedin} className="w-5 h-5" />
                </a>
                <a href="#" className="text-gray-400 hover:text-emerald-400 transition-colors">
                  <SafeIcon icon={FiTwitter} className="w-5 h-5" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;